import {
  TIntegracaoActionPayloadNode,
  TIntegracaoActionPayloadRef,
  TIntegracaoActionPayloadTransform
} from "../../../../services/CadastroDeIntegracaoGateway";

export default function usePayloadResolver() {
  const isPayloadRef = (
    node: TIntegracaoActionPayloadNode
  ): node is TIntegracaoActionPayloadRef =>
    "CampoId" in node || "Valor" in node || "Context" in node;

  const applyTransform = (
    value: unknown,
    transform?: TIntegracaoActionPayloadTransform | null
  ): unknown => {
    if (transform === "First") {
      return Array.isArray(value) ? (value[0] ?? null) : value;
    }

    if (transform === "WrapArray") {
      if (value === null || value === undefined || value === "") return [];

      return Array.isArray(value) ? value : [value];
    }

    if (transform === "SplitCsv") {
      if (Array.isArray(value)) return value;
      if (typeof value !== "string") return [];

      return value
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");
    }

    if (transform === "SplitCsvNumber") {
      if (Array.isArray(value)) return value;
      if (typeof value !== "string") return [];

      return value
        .split(",")
        .map((item) => item.trim())
        .filter((item) => /^\d+$/.test(item))
        .map(Number);
    }

    return value;
  };

  const resolvePayloadNode = (
    node: TIntegracaoActionPayloadNode,
    formValues: Record<string, unknown> | undefined,
    actionContext?: Record<string, unknown>
  ): unknown => {
    if (isPayloadRef(node)) {
      const value = (() => {
        if (typeof node.CampoId === "string")
          return formValues?.[node.CampoId] ?? node.Valor;
        if (typeof node.Context === "string")
          return actionContext?.[node.Context] ?? node.Valor;

        return node.Valor;
      })();

      return applyTransform(value, node.Transform);
    }

    return Object.entries(node).reduce<Record<string, unknown>>(
      (acc, [key, child]) => {
        acc[key] = resolvePayloadNode(child, formValues, actionContext);

        return acc;
      },
      {}
    );
  };

  const buildPayload = (
    payload: Record<string, TIntegracaoActionPayloadNode> | null | undefined,
    formValues: Record<string, unknown> | undefined,
    actionContext?: Record<string, unknown>
  ): Record<string, unknown> =>
    Object.entries(payload ?? {}).reduce<Record<string, unknown>>(
      (acc, [key, node]) => {
        acc[key] = resolvePayloadNode(node, formValues, actionContext);

        return acc;
      },
      {}
    );

  return {
    buildPayload,
    resolvePayloadNode
  };
}
